const animation = require("./round1.json");

module.exports = {
    loop: false,
    autoplay: false,
    animationData: animation,
    rendererSettings: {
        preserveAspectRatio: 'none'
    },
}